import { gql } from '@apollo/client';

export const CREATE_ORDER_CONFIRMATION_RECIPIENT = gql`
    mutation CreateOrderConfirmationRecipient($data: OrderConfirmationRecipientCreationInput!) {
        createOrderConfirmationRecipient(data: $data) {
            name
        }
    }
`;
